import {
  createUnsignedRequestAsync,
  unlinkPhysicianAsync,
  updateLinkPhysicianAsync,
  updateLinkedPhysician,
} from "api/customers";
import { createProvider } from "api/provider";
import { useMutation } from "react-query";

const useProvidersFormDialogMutations = () => {
  const createUnsignedRequestMutation = useMutation({
    mutationFn: createUnsignedRequestAsync,
  });

  const linkPhysicianMutation = useMutation({
    mutationFn: updateLinkPhysicianAsync,
  });

  const updatePhysicianMutation = useMutation({
    mutationFn: updateLinkedPhysician,
  });

  const unlinkPhysicianMutation = useMutation({
    mutationFn: unlinkPhysicianAsync,
  });

  const createPhysicianMutation = useMutation({
    mutationFn: createProvider,
  });

  return {
    createUnsignedRequestMutation,
    linkPhysicianMutation,
    updatePhysicianMutation,
    unlinkPhysicianMutation,
    createPhysicianMutation,
  };
};

export default useProvidersFormDialogMutations;
